import LearnByDoing from 'src/images/pngs/home/learn-by-doing.png';
import GuidedLearningForAllSkills from 'src/images/pngs/home/guided-learning-for-all-skills.png';
import RealWorldTraining from 'src/images/pngs/home/real-world-training.png';
import EngagingAndFunLessons from 'src/images/pngs/home/engaging-and-fun-lessons.png';
import OnlineOnDemandLearning from 'src/images/pngs/home/online-on-demand-learning.png';
import CostEffective from 'src/images/pngs/home/cost-effective.png';
import { DescriptionImage } from 'src/features/home/components/description/description.types';

export const descriptionImages: DescriptionImage[] = [
  { alt: 'learn-by-doing', title: 'Learn by doing', src: LearnByDoing },
  { alt: 'guided-learning-for-all-skills', title: 'Guided learning for all skills', src: GuidedLearningForAllSkills },
  { alt: 'real-world-training', title: 'Real-world training', src: RealWorldTraining },
  { alt: 'engaging-and-fun-lessons', title: 'Engaging and fun lessons', src: EngagingAndFunLessons },
  { alt: 'online-on-demand-learning', title: 'Online on-demand learning', src: OnlineOnDemandLearning },
  { alt: 'cost-effective', title: 'Cost-effective', src: CostEffective },
];
